'use strict';

const Reflux = require('@muzzylane/reflux');

const Globals = require('../../../app/globals');
const SignInActions = require('../actions/sign_in_actions');
const RegisterActions = require('../actions/RegisterActions');
const AccountActions = require('../actions/AccountActions');
const SubscriptionPlanActions = require('../actions/SubscriptionPlanActions');
const ServerRequest = require('../actions/request');
const Credentials = require('../local_credentials');
const ForgeError = require('../util/error');

//in the case of SignInStore, initialized = true indicates that the user
//has an authentication cookie and has receieved userInfo from the server
let initialized = false;

let madeUserInfoReq = false;
let userInfo = {};
let userSettings = null;
let userAccessCache = null; // redmine #4894
let ssoRedirect = '';
// let ltiStorage = {}; // for redmine #6302 but probably won't be used because store does not persist between the two new client pages

let action = {};
let error = null;

function signedIn() {
    const cookieValue = Credentials.getLocalCredentials();
    return !!cookieValue;
}

var SignInStore = Reflux.createStore({
    listenables: [SignInActions, RegisterActions, AccountActions, SubscriptionPlanActions],
    init: function() {
        if (signedIn()) {
            this.getUserInfo();
        }
    },

    getState: function() {
        return {
            initialized: initialized,
            signedIn: signedIn(),
            pendingUserInfo: signedIn() && !madeUserInfoReq,
            initializedLocal: initialized && userInfo.type === Globals.users.type.LOCAL,
            initializedExternal: initialized && userInfo.type === Globals.users.type.EXTERNAL,
            userInfo: userInfo,
            userSettings: userSettings,
            ssoRedirect: ssoRedirect,
            // ltiStorage: ltiStorage,
            action: action,
            error: error
        };
    },

    resetState: function() {
        initialized = false;
        userInfo = {};
        userSettings = null;
        userAccessCache = null;
        ssoRedirect = '';
    },

    setLocalAccessCode: function(third_party_id, access_code) {
        // redmine #4894
        // cache the access code locally so we can show it again when they leave the activity
        userAccessCache = { third_party_id, access_code };
    },

    getLocalAccessCode: function(third_party_id) {
        if (userAccessCache && (userAccessCache.third_party_id === third_party_id)) {
            return userAccessCache.access_code;
        }
    },
    
    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    onSignInCompleted: function(actionId, res) {
        if (!!res && res.user) {
            initialized = true;
            userInfo = res.user;
            this.emitStatus();
        }
        else {
            this.getUserInfo();
        }
    },

    onSignInFailed: function(actionId, err) {
        action = { id: actionId };
        if (err.status) {
            if (err.status >= 500) {
                action.error = new ForgeError({ message: 'Internal server error. Unable to sign in. Please try again later.' });
            }
            else {
                switch (err.status) {
                    case 400: {
                        action.error = new ForgeError({ message: 'Invalid email', uiRefs: ['email'] });
                        break;
                    }
                    case 403: {
                        action.error = new ForgeError({ message: err.responseText || 'Forbidden' });
                        break;
                    }
                    case 409: {
                        action.error = new ForgeError({ message: 'Sign in via your organization\'s identity provider'});
                        break;
                    }
                    case 422: {
                        action.error = new ForgeError({ message: 'Incorrect email or password', uiRefs: ['email', 'password'] });
                        break;
                    }
                    default: {
                        action.error = err;
                        break;
                    }
                }
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onSignInSsoCompleted: function(actionId, res) {
        initialized = true;
        action = { id: actionId };
        userInfo = res.user;
        ssoRedirect = res.redirect_uri;
        this.emitStatus();
    },

    onSignInSsoFailed: function(actionId, err) {
        action = { id: actionId };
        if (err.status) {
            if (err.status >= 500) {
                action.error = new ForgeError({ message: 'Internal server error. Unable to sign in. Please try again later.' });
            }
            else {
                switch (err.status) {
                    case 400: {
                        action.error = new ForgeError({ message: 'Invalid email', uiRefs: ['email'] });
                        break;
                    }
                    case 403: {
                        action.error = new ForgeError({ message: err.responseText || 'Forbidden' });
                        break;
                    }
                    case 409: {
                        action.error = new ForgeError({ message: 'Sign in via your organization\'s identity provider'});
                        break;
                    }
                    case 422: {
                        action.error = new ForgeError({ message: 'Incorrect email or password', uiRefs: ['email', 'password'] });
                        break;
                    }
                    default: {
                        action.error = err;
                        break;
                    }
                }
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    getUserInfo: function(){
        const self = this;
        ServerRequest.makeRequest('/authoring/users', 'GET')
        .then((res) => {
            initialized = true;
            userInfo = res;
        })
        .catch((err) => {
            console.warn("getUserInfo FAILED:", err);
            switch (err.status) {
                case 403: {
                    error = new ForgeError({ message: "Forbidden "});
                    break;
                }
                case 422: {
                    error = new ForgeError({ message: "Invalid input" });
                    break;
                }
                default: {
                    error = new ForgeError({ message:"Internal server error. Unable to fetch user information. Please try again later." });
                }
            }
        })
        .finally(() => { 
            madeUserInfoReq = true;
            self.emitStatus();
        });
    },

    onSignOutCompleted: function(res) {
        Credentials.clearLocalCredentials();
        if (res.thirdPartyUserSignedOut) {
            Credentials.clearThirdPartyCredentials();
        }

        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        Credentials.clearLocalCredentials();
        initialized = false;
        userInfo = {};
        this.emitStatus();
    },

    onResetStoreCompleted: function() {
        this.onSignOutCompleted();
    },

    onRegisterCompleted: function(actionID, res) {
        this.getUserInfo();
    },

    onRegisterFailed: function(err) {
        return;
    },

    onUpdateAccountInfoCompleted: function(actionId, userId, res) {
        // console.log(`onUpdateAccountInfoCompelted: ${actionId} ${userId} ${res}`);
        if (userId !== userInfo.id) { // prevent setting account info if we use end up allowing admins to use this action
            return;
        }

        action = { id: actionId };
        userInfo = res;
        this.emitStatus();
    },

    onUpdateAccountInfoFailed: function(actionId, userId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateAvatarCompleted: function(actionId, userId, res) {
        // console.log(`onUpdateAvatarCompleted: ${actionId} ${userId} ${res}`);
        if (userId !== userInfo.id) { // prevent setting account info if we use end up allowing admins to use this action
            return;
        }

        action = { id: actionId };
        userInfo = { ...userInfo };
        if (res.avatar_name) {
            userInfo.avatar_name = res.avatar_name;
        }
        if (res.avatar_hash) {
            userInfo.avatar_hash = res.avatar_hash;
        };
        this.emitStatus();
    },

    onUpdateAvatarFailed: function(actionId, userId, err) {
        console.log('onUpdateAvatarFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateUserPersistentDataCompleted: function(actionId, userId, res) {
        // console.log(`onUpdateUserPersistentDataCompleted: ${actionId} ${userId} ${res}`);
        if (userId !== userInfo.id) { // prevent setting account info if we use end up allowing admins to use this action
            return;
        }

        action = { id: actionId };
        userInfo = { ...userInfo };
        if (res.persistant_data) {
            userInfo.persistant_data = res.persistant_data; // Note: database column name misspells persistent
        }
        this.emitStatus();
    },
    
    onUpdateUserPersistentDataFailed: function(actionId, userId, err) {
        console.log('onUpdateUserPersistentDataFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onChangeSubscriptionPlanCompleted: function(actionId, res) {
        // console.log('onChangeSubscriptionPlanCompleted:', actionId, res);
        action = { id: actionId };
        this.getUserInfo();
    },

    onCancelSubscriptionCompleted: function(actionId, res) {
        // console.log('onCancelSubscriptionCompleted:', actionId, res);
        action = { id: actionId };
        this.getUserInfo();
    },

    onKeepAliveCompleted: function(res) {
        // console.log('onKeepAliveCompleted', res);
    },

    onGetUserSettingsCompleted: function(actionId, res) {
        action = { id: actionId };
        userSettings = res;
        this.emitStatus();
    },

    onGetUserSettingsFailed: function(actionId, err) {
        console.log('onGetUserSettingsFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateUserSettingsCompleted: function(actionId, res) {
        action = { id: actionId };
        userSettings = res;
        this.emitStatus();
    },

    onUpdateUserSettingsFailed: function(actionId, err) {
        console.log('onUpdateUserSettingsFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    
//    onSetLtiStorageCompleted: function(actionId, params) {
//        action = { id: actionId };
//        ltiStorage = params;
//        this.emitStatus();
//    },
});

module.exports = SignInStore;
